__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/25326f618638dc79b85eabb12985093091220a0d/_next/";